import React, { useEffect, useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { staffAttApi, errMsg } from '@/services/staffAttendanceApi';

/** HR: Fixed pay night shift hourly rate (Regular Payroll + My Pay). */
export const FixedPaySettings = () => {
  const [rate, setRate] = useState('');
  const [meta, setMeta] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    staffAttApi.regularPayRules().then((d) => { setRate(String(d.night_rate)); setMeta(d); }).catch((e) => toast.error(errMsg(e)));
  }, []);
  const save = async () => {
    if (rate === '' || Number(rate) < 0) { toast.error('Enter a night hourly rate of 0 or more'); return; }
    setBusy(true);
    try {
      const d = await staffAttApi.saveRegularPayRules({ night_rate: Number(rate) });
      setRate(String(d.night_rate)); setMeta(d);
      toast.success('Fixed pay night rate saved');
    } catch (e) { toast.error(errMsg(e, 'Save failed')); } finally { setBusy(false); }
  };
  return (
    <Card className="border-0 shadow-md" data-testid="fixed-pay-settings"><CardContent className="p-5 flex flex-wrap items-center gap-4">
      <div className="flex-1 min-w-[240px]">
        <h3 className="font-semibold">Fixed pay — Night shift rate</h3>
        <p className="text-sm text-gray-500">Fixed pay staff: Day shift = Fixed Pay ÷ 26 per day · Night shift = hours (nearest 15 min) × this rate.</p>
        {meta?.updated_by_name && <p className="text-[11px] text-gray-400" data-testid="fixed-pay-updated">Last changed by {meta.updated_by_name}</p>}
      </div>
      <div className="flex items-center gap-1">
        <span className="text-gray-500">₹</span>
        <Input type="number" min={0} step="0.5" value={rate} onChange={(e) => setRate(e.target.value)} className="w-[110px] bg-white" disabled={!meta} data-testid="fixed-pay-night-rate-input" />
        <span className="text-gray-500">/ hr</span>
      </div>
      <Button onClick={save} disabled={busy || !meta} className="bg-[#2D5F4F] hover:bg-[#234A3D]" data-testid="fixed-pay-save-btn">
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />}Save rate
      </Button>
    </CardContent></Card>
  );
};

export default FixedPaySettings;
